export const is32bitInteger = (value) => {
    return value < Math.pow(2, 31) - 1 && value > -Math.pow(2, 31) + 1;
};
// Avoid weird values like 251 = 250.99999999999997
export const getInteger = (value) => {
    return parseInt(value.toFixed());
};
